import { useEffect } from 'react';

import { CookiesDialog } from '../cookies-dialog';
import { CookiesContext } from './cookies-context';
import { ENVIRONMENT } from '../../../environment';
import { useBoolean } from '../../../hooks/utils/use-boolean';
import {
  useGetUserSettingsApi,
  usePatchUserSettingsApi,
} from '../../../hooks/query/user-api/use-user-settings-api';

export const CookiesProvider = ({ children }: { children: React.ReactNode }) => {
  const cookiesDialog = useBoolean();
  const { data: userSettings, isPending: isGetPending } = useGetUserSettingsApi({ enabled: false });
  const { mutate: patchUserSettings, isPending: isPatchPending } = usePatchUserSettingsApi();
  const cookiesAccepted = userSettings?.cookiesAccepted ?? false;

  useEffect(() => {
    if (!isGetPending) {
      if (!cookiesAccepted) {
        cookiesDialog.onTrue();
      } else {
        cookiesDialog.onFalse();
      }
    }
  }, [cookiesAccepted, isGetPending, cookiesDialog]);

  const setCookiesAccepted = (accepted: boolean) => {
    patchUserSettings({
      cookiesAccepted: accepted,
      acceptedTermsVersion: ENVIRONMENT.releaseVersion,
    });
  };

  return (
    <CookiesContext.Provider
      value={{
        cookiesAccepted: cookiesAccepted,
        setCookiesAccepted,
      }}
    >
      <CookiesDialog
        isOpen={cookiesDialog.value}
        onClose={cookiesDialog.onFalse}
        loading={isGetPending || isPatchPending}
        onAccept={(v) => setCookiesAccepted(v)}
      />
      {children}
    </CookiesContext.Provider>
  );
};
